module.exports = __webpack_public_path__ + "static/img/bg6.2e5ac31e.png";